import { EditSGBPCategoryData } from "../Component/editSGBPCategory/data/EditSGBPCategory.data";

export const hideAndShowFields = ( data, value ) => {
    const isChannelOne = value?.value === 1;
    return {
      ...data,
      formFields: data.formFields.map( ( field ) => {
        if ( field.id === "subCategory" || field.id === "type" ) {
          return {
            ...field,
            style: {
              ...field.style,
              containerCss: isChannelOne
                ? "col-lg-4 mb-3"
                : "d-none",
            },
            validation: isChannelOne ? [ { type: "require" } ] : [],
          };
        }
        return field;
      } ),
      initialState: {
        ...data.initialState,
        subCategory: isChannelOne ? data.initialState.subCategory : null,
        type: isChannelOne ? data.initialState.type : null,
      },
    };
};
  
export const setFieldParameter = (apiResponse) => {
    EditSGBPCategoryData.initialState.channel = apiResponse.channelId || null;
    EditSGBPCategoryData.initialState.category = apiResponse?.categoryL1Id || null;
    EditSGBPCategoryData.initialState.subCategory = apiResponse?.subCategoryL2Id || null;
    EditSGBPCategoryData.initialState.type = apiResponse?.typeL3Id || null;
    EditSGBPCategoryData.initialState.code = apiResponse?.criteriaCodeId || null;
    EditSGBPCategoryData.initialState.certificateTemplate = apiResponse?.certificateTemplateId || null;
};
